import { IAuthenticationService } from './+common/contracts/services/authentication.service.contract';
import { IMasterDataService } from './+common/contracts/master-data.service.contract';

// import { MockMasterDataService }     from './+master-data/common/mock/mock-master-data.service';
import { MasterDataService } from './+master-data/common/services/master-data.service';

import { CoreService } from './+core/common/services/core.service';
// import { MockCoreService }           from './+core/common/mock/mock-core.service';
import { MockGarmentWizardService } from './+core/common/mock/mock-garment-wizard.service';
import { GarmentWizardService } from './+core/common/services/garment-wizard.service';

// import { MockAuthenticationService } from './+auth/common/mock/mock-authentication.service';
import { AuthenticationService } from './+auth/common/services/authentication.service';
import { AuthGuardService } from './+auth/common/services/auth-guard.service';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './+common/interceptors/token.interceptor';
import { CommonService } from './+common/services/common.service';
import { InstanceService } from './+master-data/common/services/instance-service';
import { SocketService } from './+common/services/socket.service';
import { OrderWizardService } from './+common/services/order-wizard.service';
import { ExternalService } from './+core/common/services/external.service';
import { OrdersService } from './+core/common/services/orders.service';
import { LoggingService } from './+core/common/services/logging.service';
import { AntennaService } from './+common/services/antenna.service';
import { AllocationsService } from './+core/common/services/allocations.service';

// --- Provider List Config ---
// This files contains the constants to help the dependency injection subsystem to correctly resolve
// the concrete classes when abstract services are injected as providers among the application.
// Modify it only if you want to change the concrete service implementations

// Ezio: Used the OpaqueToken (putting the token name in quotes i.e. 'IAuthenticationService',
// in order to "provide" the interfaces instead of the concrete classes.
// This is a workaround because in TypeScript you can't inject directly an interface:
// when transpiled in JavaScript, the whole interface concept is lost

/** MASTER DATA **********************************************************************/
// export const MASTERDATA_PROVIDER_MOCK: any =
// [    { provide: 'IMasterDataService', useClass: MockMasterDataService } ]

export const MASTERDATA_PROVIDER: any = [
  { provide: 'IMasterDataService', useClass: MasterDataService }
];

/** CORE *****************************************************************************/
// export const CORE_PROVIDER_MOCK: any =
// [    { provide: 'ICoreService', useClass: MockCoreService } ]

export const CORE_PROVIDER: any = [
  { provide: 'ICoreService', useClass: CoreService }
];

export const ORDERS_PROVIDER: any = [
  { provide: 'IOrdersService', useClass: OrdersService },
  AllocationsService
];

export const GARMENT_WIZARD_PROVIDER_MOCK: any = [
  { provide: 'IGarmentWizardService', useClass: MockGarmentWizardService }
];

export const GARMENT_WIZARD_PROVIDER: any = [
  { provide: 'IGarmentWizardService', useClass: GarmentWizardService }
];

export const ORDER_WIZARD_PROVIDER: any = [
  { provide: 'IOrderWizardService', useClass: OrderWizardService }
];

/** AUTH *****************************************************************************/
// export const AUTH_PROVIDER_MOCK: any =
// [    { provide: 'IAuthenticationService', useClass: MockAuthenticationService } ]

export const AUTH_PROVIDER: any = [
  { provide: 'IAuthenticationService', useClass: AuthenticationService }
];

export const AUTH_GUARD_PROVIDER: any = { provide: AuthGuardService };

export const COMMON_PROVIDER: any = [
  { provide: 'ICommonService', useClass: CommonService },
  { provide: 'IInstanceService', useClass: InstanceService },
  { provide: 'ISocketService', useClass: SocketService },
  { provide: 'IExternalService', useClass: ExternalService},
  { provide: 'AntennaService', useClass: AntennaService},
  LoggingService
];

// export const SOCKET_PROVIDER: any = [
//     { provide: 'ISocketService', useClass: SocketService }
//   ];
  

export const TOKEN_INTERCEPTOR: any = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  }
];



// WEBPACK FOOTER //
// ./src/app/provider-list.config.ts